import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Github, Rss, Globe } from 'lucide-react';
import Newsletter from './Newsletter';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-100 mt-24">
      {/* Newsletter Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <Newsletter />
      </div>

      {/* Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12 border-t border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About */}
          <div>
            <h3 className="text-lg font-light mb-4">AI Banter with Riddhi</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Exploring the intersection of artificial intelligence and ethics.
              Writing to learn, learning to write.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-light mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-600 hover:text-black transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/archive" className="text-sm text-gray-600 hover:text-black transition-colors">
                  Archive
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-sm text-gray-600 hover:text-black transition-colors">
                  Topics
                </Link>
              </li>
              <li>
                <Link to="/learn" className="text-sm text-gray-600 hover:text-black transition-colors">
                  Learn
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-black transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-black transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-sm text-gray-600 hover:text-black transition-colors">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-lg font-light mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/in/riddhi-tikoo-32a02a2b7/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://github.com/riddhitik"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
                aria-label="GitHub"
              >
                <Github size={20} />
              </a>
              <a
                href="https://safeplayai.org"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
                aria-label="SafePlayAI"
              >
                <Globe size={20} />
              </a>
              <Link
                to="/rss"
                className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
                aria-label="RSS Feed"
                title="Subscribe via RSS"
              >
                <Rss size={20} />
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-600">
            © {currentYear} AI Banter with Riddhi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
